/* eslint-disable import/no-anonymous-default-export */
const fontFamily = '"Kanit"'
export default {
  fontFamily: fontFamily,
  h1: {
    fontWeight: 500,
    letterSpacing: '0px'
  },
  h2: {
    fontWeight: 500,
    fontSize: 30,
    letterSpacing: '0px'
  },
  h2_emphasize: {
    fontWeight: 500,
    fontSize: 30,
    letterSpacing: '0px',
    color : '#6694CC',
    fontFamily: fontFamily,
  },
  h2_information: {
    fontWeight: 500,
    fontSize: 30,
    letterSpacing: '0px',
    color : '#5DA196',
    fontFamily: fontFamily,
  },
  h3: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: '0px'
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '0px'
  },
  h4_hilight: {
    fontFamily: fontFamily,
    color: 'white',
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '0px'
  },
  h5: {
    fontWeight: 500,
    fontSize: 20,
    letterSpacing: '0px'
  },
  h6: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '0px'
  },
  number_heading: {
    fontFamily: fontFamily,

    fontWeight: 500,
    fontSize: '36px',
    letterSpacing: '0px'
  },
  overline: {
    fontWeight: 500
  },
  label: {
    fontWeight: 500,
    fontSize: 16,
    letterSpacing: '0px',
    color : '#828282',
    fontFamily: fontFamily,
  },
  sub_label: {
    fontSize: 16,
    fontWeight: 300,
    letterSpacing: '0px',
    color : '#A0A0A0',
    fontFamily: fontFamily,
  },
  s14_fw300: {
    fontSize: 14,
    fontWeight: 300,
    letterSpacing: '0px',
    color : '#A0A0A0',
    fontFamily: fontFamily,
  },
  s14_fw400: {
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: '0px',
    color : '#A0A0A0',
    fontFamily: fontFamily,
  },
  s14_fw600: {
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: '0px',
    color : '#A0A0A0',
    fontFamily: fontFamily,
  },
  sub_label_black: {
    fontSize: 16,
    fontWeight: 400,
    letterSpacing: '0px',
    color : '#404349',
    fontFamily: fontFamily,
  },
  label_sub1: {
    fontWeight: 500,
    fontSize: 14,
    letterSpacing: '0px',
    color : '#828282',
    fontFamily: fontFamily,
  }
};
